import apiTerminal from './ApiTerminal';
import * as fromTerminal from './constants';
import * as fromPayment from '../main/payment/constants';
import * as fromRegisterPayment from '../register/payment/constants';
import webTerminal from './Terminal';
import {
  discoverReaders,
  handleReaderSelect,
  handleReaderSelectCancel,
} from './actions';
import * as selectReaderTypes from '../register/webReader/constants';
import { activeShopReaderLocationId, isApiReaderEnabledForShop } from '../auth/selectors';
import { getStrategyByName } from './helpers';
import { Logger } from '../../modules/infra/observability/logger';

export const handleReaderTransactions = (state, action, dispatch) => {
  const canUseApiTerminal = isApiReaderEnabledForShop(state) && action.strategy === 'pay';
  const terminal = canUseApiTerminal ? apiTerminal : webTerminal;

  switch (action.type) {
    case fromRegisterPayment.CREATE_WEBREADER_TRANSACTION: {
      const strategyHandlers = getStrategyByName(action.strategy);
      if (!terminal.isConnected()) {
        strategyHandlers.resetWebreaderPayment(dispatch);
        break;
      }

      strategyHandlers.collectPaymentMethod(state, action, dispatch);
      break;
    }

    case fromTerminal.COLLECT_PAYMENT_METHOD_SUCCESS: {
      const strategyHandlers = getStrategyByName(action.strategy);
      if (!terminal.isConnected()) {
        strategyHandlers.resetWebreaderPayment(dispatch);
        break;
      }

      strategyHandlers.process(state, action, dispatch);
      break;
    }

    case fromTerminal.PROCESS_PAYMENT_SUCCESS: {
      const strategyHandlers = getStrategyByName(action.strategy);
      if (!terminal.isConnected()) {
        strategyHandlers.resetWebreaderPayment(dispatch);
        break;
      }

      strategyHandlers.capture(state, action, dispatch);
      break;
    }

    case fromRegisterPayment.RESET:
    case fromRegisterPayment.READER_TRANSACTION_FAIL:
    case fromPayment.CANCEL_PAYMENT: {
      const paymentStrategyHandlers = getStrategyByName('pay');
      paymentStrategyHandlers.dispose();
      break;
    }

    case fromTerminal.READER_TRANSACTION_SUCCESS: {
      const paymentStrategyHandlers = getStrategyByName('pay');
      paymentStrategyHandlers.readerTransactionSuccess(state, action, dispatch);
      break;
    }

    case fromTerminal.READER_TRANSACTION_FAIL: {
      const paymentStrategyHandlers = getStrategyByName('pay');
      paymentStrategyHandlers.readerTransactionFail(state, action, dispatch);
      break;
    }

    case fromTerminal.READER_REFUND_SUCCESS: {
      const paymentStrategyHandlers = getStrategyByName('refund');
      paymentStrategyHandlers.readerTransactionSuccess(state, action, dispatch);
      break;
    }

    case fromTerminal.READER_REFUND_FAIL: {
      const paymentStrategyHandlers = getStrategyByName('refund');
      paymentStrategyHandlers.readerTransactionFail(state, action, dispatch);
      break;
    }

    case fromTerminal.CANCEL_TRANSACTION: {
      const strategyHandlers = getStrategyByName(action.strategy);
      strategyHandlers.handleCancelTransaction(state, action, dispatch);
      break;
    }

    case fromTerminal.WEBREADER_ERROR: {
      Logger.log('Webreader error', {
        shop: state.auth.shop,
        error: action,
        location: terminal.readerLocationId,
        terminalType: terminal.getName(),
        action: 'Webreader error',
      });
      const strategyHandlers = getStrategyByName(action.strategy);
      strategyHandlers.handleWebreaderError(state, action);
      break;
    }

    default:
  }
};

export const handleReaderConnection = (state, action, dispatch) => {
  switch (action.type) {
    case selectReaderTypes.DISCOVER_READERS: {
      const readerLocationId = activeShopReaderLocationId(state);
      const isApiReaderEnabled = isApiReaderEnabledForShop(state);
      discoverReaders(readerLocationId, dispatch, action.strategy, isApiReaderEnabled);
      break;
    }

    case selectReaderTypes.SELECT_READER_DONE:
      handleReaderSelect(dispatch)(state, action);
      break;

    case selectReaderTypes.SELECT_READER_CANCEL:
      handleReaderSelectCancel(dispatch)(state, action);
      break;

    default:
  }
};
